import apiClient from '../utils/apiClient';

/**
 * Statistics API Services
 * Thống kê tổng quan
 */

export const statsAPI = {
  /**
   * Lấy thống kê tổng quan
   * @returns {Promise<Object>} Thống kê tổng quan
   */
  getOverview: async () => {
    return await apiClient.get({
      url: '/stats/overview',
    });
  },
};

